export default {
  title: '同州天气微信公众服务平台',
  defaultStationObj: {
    adminCode: '610523',
    stationName: '大荔县',
    lon: 109.9689,
    lat: 34.7975,
    station_id_c: '57043',
  },
  staIds: '',
  imgUrl: `https://tzwx.sxktqx.com/columnfiles`,
  fileUrl: `https://tzwx.sxktqx.com/columnfiles`,
  baseUrl: 'http://124.70.8.80:8721',
  WECHAT_APPID: 'wx0ac67228b99edf08',
}

